import React from "react";
import UnitIngredSmall from "./UnitIngredSmall";

function IngredSmall({
  selectedOption,
  handleCloseBtn,
  blenderData,
  radarChartData,
  colorCodes,
  goClicked,
  ingredientsListRef,
}) {
  return (
    <div
      className={`visible md:invisible
                  sm:h-fit md:h-0
                  flex pt-6 justify-center
                  bg-white bg-opacity-80
                  shadow-black
                  shadow-[5px_-5px_10px_-6px_rgba(0,0,0,0.3)]
                  `}
    >
      <div className="flex flex-wrap gap-x-4 justify-center">
        {selectedOption.map((option, index) => (
          <div key={[index]} className="flex">
            <div>
              <UnitIngredSmall
                ind={index}
                onClick={(event) => handleCloseBtn(event, index)}
                option={option}
                blenderData={blenderData}
                radarChartData={radarChartData}
                selectedOption={selectedOption}
                colorCodes={colorCodes}
              />
            </div>
            <div className="font-bold text-base -mr-4 px-1 py-20">
              {index !== selectedOption.length - 1 && "+"}
            </div>
          </div>
        ))}
        <div className="w-full flex gap-x-2 -mt-6 mb-2 justify-center font-bold">
          <p>=</p>
          <p className={`${!goClicked && "animate-bounce"}`}>?</p>
        </div>
      </div>

      <div ref={ingredientsListRef} className="-mt-48" />
    </div>
  );
}

export default IngredSmall;
